// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  TITLE: 'verido',
  ENABLE_AUTH: true,
  AUTH_HOST: 'https://localhost:3000/api',
  AUTH_BACKEND: {
    AUTH_HEADER_PREFIX: 'Bearer',
    AUTH_PARAM: 'username',
    JWT: {
      default: true,
      AUTH_LOGIN_ENDPOINT: `/login`,
      AUTH_FORGOTPWD_ENDPOINT: `/password/reset/send/`,
      AUTH_VERIFICATION_ENDPOINT: `/password/reset/update/`,
      TOKEN_REFRESH_ENDPOINT: `/api/users/refresh_token/`
    }
  },
  API_HOST: 'https://api.verido.app',
  USERS_BACKEND: {
    PASSWORD_CHANGE_ENDPOINT: `/api/users/password/change/`,
    PASSWORD_RESET_ENDPOINT: `/api/users/password/reset/`,
    PASSWORD_RESET_CONFIRM_ENDPOINT: `/api/users/password/reset/confirm/`,
    REGISTRATION_ENDPOINT: `/api/users/registration/`,
    USER_ENDPOINT: `/api/users/user/`,
    USER_PATCH_ENDPOINT: `/api/users/profile/`
  },
  INSTITUTION_BACKEND: {
    INSTITUTION_POST_ENDPOINT: '/institution/add-institution',
    INSTITUTION_PUT_ENDPOINT: '/institution/edit-institution/',
    INSTITUTION_GET_ENDPOINT: '/institution/get-institutions',
    INSTITUTION_GET_DETAILS_ENDPOINT: '/institution/get-institution/',
  },
  CONSULTANT_BACKEND: {
    CONSULTANT_POST_ENDPOINT: '/consultants/add-new',
    CONSULTANT_SEARCH_ENDPOINT: '/consultants/fetch-all/',
    CONSULTANT_GET_ENDPOINT: '/consultants/fetch-one/',
    CONSULTANT_DELETE_ENDPOINT: '/consultants/',
  },
  BUSINESS_BACKEND: {
    BUSINESS_POST_ENDPOINT: '/business/',
    BUSINESS_GET_ENDPOINT: '/business/',
    BUSINESS_PUT_ENDPOINT: '/business/',
    BUSINESS_DELETE_ENDPOINT: '/business/',
  },
  PAGE_SIZE: 10
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
